module.exports = __webpack_public_path__ + "img/iceskating004.89ff7d83.jpg";